export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export enum DeviceCheckResult {
  Fail = 'FAIL',
  Pass = 'PASS'
}

export type DeviceCheckResultsInput = {
  date: Scalars['String']['input'];
  deviceCheck: DeviceCheckType;
  identifier: Scalars['String']['input'];
  operatingSystem: OperatingSystem;
  product: ProductCheckInput;
  version: Scalars['String']['input'];
};

export enum DeviceCheckStage {
  ExternalApplicationsProhibited = 'EXTERNAL_APPLICATIONS_PROHIBITED',
  ExternalStorageProhibited = 'EXTERNAL_STORAGE_PROHIBITED',
  MeasuredBatteryLevel = 'MEASURED_BATTERY_LEVEL',
  MinimumOsVersion = 'MINIMUM_OS_VERSION',
  MinimumUnityVersion = 'MINIMUM_UNITY_VERSION',
  MinScreenSize = 'MIN_SCREEN_SIZE',
  MultipleMonitorsProhibited = 'MULTIPLE_MONITORS_PROHIBITED',
  RequiredActEndpoint = 'REQUIRED_ACT_ENDPOINT',
  RequiredProductEndpoint = 'REQUIRED_PRODUCT_ENDPOINT',
  RequiresDeviceIntegrity = 'REQUIRES_DEVICE_INTEGRITY',
  RequiresDeviceLockdown = 'REQUIRES_DEVICE_LOCKDOWN',
  RequiresSecureNetwork = 'REQUIRES_SECURE_NETWORK'
}

export type DeviceCheckStageResultInput = {
  deviceCheckStage: DeviceCheckStage;
  expectedValue?: InputMaybe<Scalars['String']['input']>;
  result: DeviceCheckResult;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum DeviceCheckType {
  Exam = 'EXAM',
  Install = 'INSTALL',
  Jit = 'JIT',
  Precheck = 'PRECHECK'
}

export type GetDeviceCheckResultsByRegistrationInput = {
  deviceid?: InputMaybe<Scalars['String']['input']>;
  includeCompleteResult?: InputMaybe<Scalars['Boolean']['input']>;
  registrationid: Scalars['String']['input'];
};

export type GetDeviceCheckResultsByTestCenterInput = {
  deviceid: Scalars['String']['input'];
  includeCompleteResult?: InputMaybe<Scalars['Boolean']['input']>;
  tcid: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptAdminTerms: Scalars['String']['output'];
  deRegisterDevice: Scalars['String']['output'];
  /** Invalidate all caches in the TLP subgraph, for internal use only. */
  invalidateAllCachesInTlpSubgraph: Scalars['String']['output'];
  /** Invalidate all caches in the TSR subgraph, for internal use only. */
  invalidateAllCachesInTsrSubgraph: Scalars['String']['output'];
  /** Invalidate all caches in the Unity subgraph, for internal use only. */
  invalidateAllCachesInUnitySubgraph: Scalars['String']['output'];
  optInOutEos: Scalars['String']['output'];
  postLaunchStatusUpdate: Scalars['String']['output'];
  registerDevice: Scalars['String']['output'];
  unity2Login: UnityAuthToken;
  unityRefreshToken: UnityAuthToken;
  updateRegistrationDeviceCheckResults: Scalars['String']['output'];
  updateTestCenterDeviceCheckResults: Scalars['String']['output'];
  /** @deprecated Use updateTestCenterDeviceCheckResults and updateRegistrationDeviceCheckResults instead. */
  updateUnityDeviceCheckResults: Scalars['String']['output'];
  vendorCallbackStatusUpdate: UnityTestLaunchIdentifier;
};


export type MutationAcceptAdminTermsArgs = {
  testLaunchIdentifierInput: UnityTestLaunchIdentifierInput;
};


export type MutationDeRegisterDeviceArgs = {
  deviceId: Scalars['String']['input'];
  tcId: Scalars['String']['input'];
};


export type MutationOptInOutEosArgs = {
  optIn: Scalars['Boolean']['input'];
  registrationId: Scalars['String']['input'];
};


export type MutationPostLaunchStatusUpdateArgs = {
  assessmentId: Scalars['Int']['input'];
  testLaunchIdentifierInput: UnityTestLaunchIdentifierInput;
};


export type MutationRegisterDeviceArgs = {
  deviceId: Scalars['String']['input'];
  tcId: Scalars['String']['input'];
};


export type MutationUnity2LoginArgs = {
  input: Unity2UserLoginInput;
};


export type MutationUpdateRegistrationDeviceCheckResultsArgs = {
  input: UnityUpdateRegistrationDeviceCheckResultsInput;
};


export type MutationUpdateTestCenterDeviceCheckResultsArgs = {
  input: UnityUpdateTestCenterDeviceCheckResultsInput;
};


export type MutationUpdateUnityDeviceCheckResultsArgs = {
  input: UnityUpdateDeviceCheckResultsInput;
};


export type MutationVendorCallbackStatusUpdateArgs = {
  returnParameters: Scalars['String']['input'];
};

export enum OperatingSystem {
  Android = 'ANDROID',
  Chromeos = 'CHROMEOS',
  Ios = 'IOS',
  Macos = 'MACOS',
  Windows = 'WINDOWS'
}

export type ProductAttributesInput = {
  programs: Array<Scalars['String']['input']>;
};

export type ProductCheckInput = {
  attributes?: InputMaybe<ProductAttributesInput>;
  checkResults: ProductDeviceCheckResultsInput;
  displayOnDevice: Scalars['Boolean']['input'];
  identifier: Scalars['String']['input'];
  isDisabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type ProductDeviceCheckResultsInput = {
  result: DeviceCheckResult;
  tests: Array<DeviceCheckStageResultInput>;
};

export type Query = {
  __typename?: 'Query';
  /** Provide assessment information with optimal performance. It uses a dynamically updated cache that stays synchronized with the latest assessment status changes. */
  assessmentsInfo: UnityTlpAssessmentInfo;
  getUnityConfig: UnityConfiguration;
  me: UnityMe;
  myAdminTerms: UnityTlpTerms;
  myPhotoUrl: UnityPhotoUrl;
  myRegistrations: Array<UnityRegistrationInfo>;
  /** Get encrypted registration launch code mapping, for internal use only. */
  regLaunchCodeMapping: Scalars['String']['output'];
  registration?: Maybe<UnityRegistrationInfo>;
  registrationDeviceCheckResults?: Maybe<UnityRegistrationDeviceCheckResults>;
  testCenter: UnityTestCenter;
  testCenterDeviceCheckResults?: Maybe<UnityTestCenterDeviceCheckResults>;
  testLaunchRequestData: UnityTestLaunchRequestData;
  /** Get test site info by UnityRegistrationInfo.test_center.tc_id */
  testSite: UnityTestSite;
  tlpGuard: Scalars['String']['output'];
  verifyTestCenterDeviceMapping: Scalars['Boolean']['output'];
};


export type QueryAssessmentsInfoArgs = {
  testLaunchIdentifierInput: UnityTestLaunchIdentifierInput;
};


export type QueryGetUnityConfigArgs = {
  input: UnityGetConfigInput;
};


export type QueryMyAdminTermsArgs = {
  testLaunchIdentifierInput: UnityTestLaunchIdentifierInput;
};


export type QueryMyRegistrationsArgs = {
  currentDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRegLaunchCodeMappingArgs = {
  profileId: Scalars['String']['input'];
};


export type QueryRegistrationArgs = {
  currentDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type QueryRegistrationDeviceCheckResultsArgs = {
  input: GetDeviceCheckResultsByRegistrationInput;
};


export type QueryTestCenterArgs = {
  tcid: Scalars['String']['input'];
};


export type QueryTestCenterDeviceCheckResultsArgs = {
  input: GetDeviceCheckResultsByTestCenterInput;
};


export type QueryTestLaunchRequestDataArgs = {
  assessmentId: Scalars['Int']['input'];
  testLaunchIdentifierInput: UnityTestLaunchIdentifierInput;
};


export type QueryTestSiteArgs = {
  tc_id: Scalars['Int']['input'];
};


export type QueryTlpGuardArgs = {
  testLaunchIdentifierInput: UnityTestLaunchIdentifierInput;
};


export type QueryVerifyTestCenterDeviceMappingArgs = {
  deviceId: Scalars['String']['input'];
  tcId: Scalars['String']['input'];
};

export type Unity2UserLoginInput = {
  launchCode?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  roomCode?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type UnityAccessibility = {
  __typename?: 'UnityAccessibility';
  calculatorEndpoint?: Maybe<Scalars['String']['output']>;
  os?: Maybe<UnityOs>;
};

export enum UnityAccomType {
  ScreenReader = 'SCREEN_READER',
  Speech2Text = 'SPEECH2TEXT',
  Text2Speech = 'TEXT2SPEECH'
}

export type UnityAccommodation = {
  __typename?: 'UnityAccommodation';
  /** Accommodation PIN created by the TAA application. */
  accom_pin?: Maybe<Scalars['String']['output']>;
  /** Datetime when the accommodation is created. */
  accom_request_date?: Maybe<Scalars['String']['output']>;
  /** List of accommodations. */
  accommodations?: Maybe<Array<Scalars['String']['output']>>;
  /** Application/person who creates the record. */
  created_by?: Maybe<Scalars['String']['output']>;
  /** Datetime when the record is created. */
  created_dt?: Maybe<Scalars['String']['output']>;
  /** Accommodation identifier from the accommodations system. */
  id: Scalars['ID']['output'];
  /** Application/person who modifies the record. */
  modified_by?: Maybe<Scalars['String']['output']>;
  /** Datetime when the record is modified. */
  modified_dt?: Maybe<Scalars['String']['output']>;
  /** Registration ID. */
  registration_id?: Maybe<Scalars['Int']['output']>;
  /** Accommodation status flag. Possible values: P - Pending, A - Approved, R - Rejected. */
  status?: Maybe<Scalars['String']['output']>;
};

export type UnityAddress = {
  __typename?: 'UnityAddress';
  address: Scalars['String']['output'];
  address2?: Maybe<Scalars['String']['output']>;
  address3?: Maybe<Scalars['String']['output']>;
  address4?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  postalCode: Scalars['String']['output'];
  state: Scalars['String']['output'];
};

export type UnityAdminInfo = {
  __typename?: 'UnityAdminInfo';
  /** The description of the testing site. */
  admin_desc?: Maybe<Scalars['String']['output']>;
  /** The end date of test administration. */
  admin_end_date?: Maybe<Scalars['String']['output']>;
  /** The integer ID of the admin. */
  admin_id: Scalars['ID']['output'];
  /** The name of the testing site. */
  admin_name?: Maybe<Scalars['String']['output']>;
  /** The report date of test administration. */
  admin_score_report_date?: Maybe<Scalars['String']['output']>;
  /** The starting date of test administration. */
  admin_start_date?: Maybe<Scalars['String']['output']>;
  /** The testing window end date of test administration. */
  admin_test_end_date?: Maybe<Scalars['String']['output']>;
  /** The testing window start date of test administration. */
  admin_test_start_date?: Maybe<Scalars['String']['output']>;
  /** The deadline date for college choice test administration. */
  college_choice_deadline_date?: Maybe<Scalars['String']['output']>;
  /** The application/person who creates the record. */
  created_by?: Maybe<Scalars['String']['output']>;
  /** Datetime when the record is created. */
  created_dt?: Maybe<Scalars['String']['output']>;
  /** The date when the late fee applies. */
  late_fee_date?: Maybe<Scalars['String']['output']>;
  /** The photo hardcopy deadline date of test administration. */
  photo_hardcopy_deadline?: Maybe<Scalars['String']['output']>;
  /** The date when the photo is required. */
  photo_required?: Maybe<Scalars['String']['output']>;
  /** The photo upload deadline date. */
  photo_upload_deadline?: Maybe<Scalars['String']['output']>;
  /** The integer ID of the program cycle. */
  program_cycle_id?: Maybe<Scalars['Int']['output']>;
  /** Reference admin ID from the scheduling system for this admin (TCMS / TCNM). */
  ref_admin_id?: Maybe<Scalars['String']['output']>;
  /** The deadline date for regular registration. */
  regular_reg_deadline?: Maybe<Scalars['String']['output']>;
  /** Indicates when the standby cancellation/refund process runs. */
  standby_cancellation_date?: Maybe<Scalars['String']['output']>;
  /** The standby deadline of test administration. */
  standby_deadline_date?: Maybe<Scalars['String']['output']>;
  /** The cut-off date for enrollment at this site. */
  web_cutoff_date?: Maybe<Scalars['String']['output']>;
  /** The web-available date for enrollment at this site. */
  web_score_avail_date?: Maybe<Scalars['String']['output']>;
};

export type UnityAuthToken = {
  __typename?: 'UnityAuthToken';
  accessToken: Scalars['String']['output'];
  exp: Scalars['Float']['output'];
  iat: Scalars['Float']['output'];
};

export type UnityColors = {
  __typename?: 'UnityColors';
  primary: Scalars['String']['output'];
  secondary: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type UnityConfiguration = {
  __typename?: 'UnityConfiguration';
  _id: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  product: UnityProduct;
  version: Scalars['String']['output'];
};

export type UnityDeliveryEngine = {
  __typename?: 'UnityDeliveryEngine';
  engineType: Scalars['String']['output'];
  idleTimeout: Scalars['Int']['output'];
};

export type UnityDeviceCheck = {
  __typename?: 'UnityDeviceCheck';
  JIT?: Maybe<UnityPreCheckJit>;
  exam?: Maybe<UnityExam>;
  install?: Maybe<UnityInstall>;
  preCheck?: Maybe<UnityPreCheckJit>;
};

export type UnityExam = {
  __typename?: 'UnityExam';
  externalStorageProhibited: Scalars['Boolean']['output'];
  minimumBatteryLevel: Scalars['Int']['output'];
  multipleMonitorsProhibited?: Maybe<Scalars['Boolean']['output']>;
  repeatFrequency: Scalars['Int']['output'];
  touchScreen: Scalars['String']['output'];
};

export type UnityGetConfigInput = {
  configversion?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  platformversion?: InputMaybe<Scalars['String']['input']>;
  testcenterid: Scalars['String']['input'];
};

export type UnityInstall = {
  __typename?: 'UnityInstall';
  externalStorageProhibited: Scalars['Boolean']['output'];
  minScreenSize: UnityMinScreenSize;
  minimumBatteryLevel: Scalars['Int']['output'];
  minimumOSVersion: UnityMinimumOsVersion;
  minimumUnityVersion: UnityMinimumUnityVersion;
  multipleMonitorsProhibited?: Maybe<Scalars['Boolean']['output']>;
  requiredACTEndpoint: Scalars['String']['output'];
  requiresDeviceIntegrity: Scalars['Boolean']['output'];
  requiresDeviceLockdown?: Maybe<Scalars['Boolean']['output']>;
  requiresSecureNetwork: Scalars['Boolean']['output'];
};

export type UnityMe = {
  __typename?: 'UnityMe';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  photoExempt: Scalars['Boolean']['output'];
};

export type UnityMinScreenSize = {
  __typename?: 'UnityMinScreenSize';
  Android: Scalars['String']['output'];
  ChromeOS: Scalars['String']['output'];
  MacOS?: Maybe<Scalars['String']['output']>;
  Windows?: Maybe<Scalars['String']['output']>;
  iOS: Scalars['String']['output'];
};

export type UnityMinimumOsVersion = {
  __typename?: 'UnityMinimumOSVersion';
  Android: Scalars['String']['output'];
  ChromeOS: Scalars['String']['output'];
  MacOS?: Maybe<Scalars['String']['output']>;
  Windows?: Maybe<Scalars['String']['output']>;
  iOS: Scalars['String']['output'];
};

export type UnityMinimumUnityVersion = {
  __typename?: 'UnityMinimumUnityVersion';
  Android: Scalars['String']['output'];
  ChromeOS: Scalars['String']['output'];
  MacOS?: Maybe<Scalars['String']['output']>;
  Windows?: Maybe<Scalars['String']['output']>;
  iOS: Scalars['String']['output'];
};

export type UnityOs = {
  __typename?: 'UnityOs';
  MacOS?: Maybe<UnityTools>;
  Windows?: Maybe<UnityTools>;
};

export type UnityPhotoUrl = {
  __typename?: 'UnityPhotoUrl';
  durationInSec?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UnityPreCheckJit = {
  __typename?: 'UnityPreCheckJIT';
  externalApplicationsProhibited: Scalars['Boolean']['output'];
  externalStorageProhibited: Scalars['Boolean']['output'];
  minScreenSize: UnityMinScreenSize;
  minimumBatteryLevel: Scalars['Int']['output'];
  minimumOSVersion: UnityMinimumOsVersion;
  minimumUnityVersion: UnityMinimumUnityVersion;
  multipleMonitorsProhibited?: Maybe<Scalars['Boolean']['output']>;
  requiredACTEndpoint: Scalars['String']['output'];
  requiredProductEndpoints: Array<Scalars['String']['output']>;
  requiresDeviceIntegrity: Scalars['Boolean']['output'];
  requiresDeviceLockdown?: Maybe<Scalars['Boolean']['output']>;
  requiresSecureNetwork: Scalars['Boolean']['output'];
};

export type UnityProduct = {
  __typename?: 'UnityProduct';
  _id: Scalars['String']['output'];
  attributes?: Maybe<UnityProductAttributes>;
  deliveryEngine?: Maybe<UnityDeliveryEngine>;
  deviceCheck: UnityDeviceCheck;
  displayOnDevice: Scalars['Boolean']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  testCenterProviding: Scalars['Boolean']['output'];
  uiConfig?: Maybe<UnityUiConfig>;
  version?: Maybe<Scalars['String']['output']>;
};

export type UnityProductAttributes = {
  __typename?: 'UnityProductAttributes';
  accessibility?: Maybe<UnityAccessibility>;
  programs?: Maybe<Array<Scalars['String']['output']>>;
};

export type UnityProgramInfo = {
  __typename?: 'UnityProgramInfo';
  /** The application/person who creates the record. */
  created_by?: Maybe<Scalars['String']['output']>;
  /** Datetime when the record is created. */
  created_dt?: Maybe<Scalars['String']['output']>;
  /** The application/person who modifies the record. */
  modified_by?: Maybe<Scalars['String']['output']>;
  /** Datetime when the record is modified. */
  modified_dt?: Maybe<Scalars['String']['output']>;
  /** The parent program ID. */
  parent_program_id?: Maybe<Scalars['String']['output']>;
  /** The description of the program. */
  program_desc?: Maybe<Scalars['String']['output']>;
  /** The last day this program is valid. */
  program_end_dt?: Maybe<Scalars['String']['output']>;
  /** The program ID of the product or test type. */
  program_id: Scalars['ID']['output'];
  /** The name of the program. */
  program_name: Scalars['String']['output'];
  /** The first day this program is valid. */
  program_start_dt?: Maybe<Scalars['String']['output']>;
  /** Reference program ID from the TCMS system. */
  ref_program_id?: Maybe<Scalars['String']['output']>;
};

export type UnityRegModule = {
  __typename?: 'UnityRegModule';
  /** Unique identifier of the module (not registration specific). */
  moduleId?: Maybe<Scalars['Int']['output']>;
  /** Name of the module. */
  name: Scalars['String']['output'];
  /** Identifier of the registration the module belongs to. */
  registrationId?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the module specific to a registration. */
  registrationModuleId: Scalars['ID']['output'];
};

export enum UnityRegStateType {
  Completed = 'COMPLETED',
  Preparing = 'PREPARING',
  Testing = 'TESTING'
}

export type UnityRegistration = {
  __typename?: 'UnityRegistration';
  /** Test administration ID. */
  admin_id: Scalars['Int']['output'];
  /** B2B Person ID. */
  b2b_person_id?: Maybe<Scalars['String']['output']>;
  /** Date of confirmation. */
  confirm_date?: Maybe<Scalars['String']['output']>;
  /** Application/person who creates the record. */
  created_by?: Maybe<Scalars['String']['output']>;
  /** Datetime when the record is created. */
  created_dt?: Maybe<Scalars['String']['output']>;
  /** Delivery Method from External Registration System - PBT or CBT or RPT. */
  delivery_method?: Maybe<Scalars['String']['output']>;
  /** Code to denote the district of the reporting attending high school. */
  district_code?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the registration eos opt-in. */
  eos_opt_in?: Maybe<Scalars['Boolean']['output']>;
  /** External registration ID in external system. */
  ext_reg_id?: Maybe<Scalars['String']['output']>;
  /** External registration system in the external system. */
  ext_reg_system?: Maybe<Scalars['String']['output']>;
  /** Student ID from the external registration platform. */
  ext_student_id?: Maybe<Scalars['String']['output']>;
  /** Registrant's grade associated with the admin. */
  grade?: Maybe<Scalars['String']['output']>;
  /** High school code associated with the registration. */
  high_school_code?: Maybe<Scalars['String']['output']>;
  /** IAM ID of the person. */
  iam_id?: Maybe<Scalars['String']['output']>;
  /** Unique registration ID. */
  id: Scalars['ID']['output'];
  /** Indicates whether the registration is locked due to chargeback and shouldn't be modified via MyACT or SF. */
  locked?: Maybe<Scalars['Boolean']['output']>;
  /** Application/person who modifies the record. */
  modified_by?: Maybe<Scalars['String']['output']>;
  /** Datetime when the record is modified. */
  modified_dt?: Maybe<Scalars['String']['output']>;
  /** Historic examinee act ID from External Registration system. */
  orig_examinee_act_id?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the student wants to receive a paper score report. Possible values: Y - Yes, N - No. */
  paper_score_report?: Maybe<Scalars['String']['output']>;
  /** Date the photo added email was sent. */
  photo_added_email_sent_dt?: Maybe<Scalars['String']['output']>;
  /** Photo uploaded date to Test Delivery engine. */
  photo_delivery_engine_sent_dt?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the student has a photo exemption. Possible values: Y - Yes, N - No. */
  photo_exemption?: Maybe<Scalars['String']['output']>;
  /** ID from Profile360 service. */
  profile_id: Scalars['String']['output'];
  /** Registration ID of the reference registration record. */
  ref_reg_id?: Maybe<Scalars['Int']['output']>;
  /** Registration status of the reference registration record. */
  ref_reg_status?: Maybe<Scalars['String']['output']>;
  /** Registration system of the reference registration record. */
  ref_reg_sys?: Maybe<Scalars['Int']['output']>;
  /** Code unique to the student/registration combo. Given to students to login and complete non-cognitive portion of the questions. */
  reg_claim_code?: Maybe<Scalars['String']['output']>;
  /** Method used to create the registration. Possible values: F - Folder, W - Web. */
  registration_method?: Maybe<Scalars['String']['output']>;
  /** Registration Type from External Registration System - Battery or Modular. */
  registration_type?: Maybe<Scalars['String']['output']>;
  /** Datetime when seat is blocked in TCMS. */
  seat_blocked_dt?: Maybe<Scalars['String']['output']>;
  /** State ID of the examinee. */
  state_id?: Maybe<Scalars['String']['output']>;
  /** Status of examinee's registration. Possible values: P - Pending, R - Registered, T - Tested, C - Changed, N - Test Not Taken, V - Void. */
  status?: Maybe<Scalars['String']['output']>;
  /** Test date in format 'yyyy-mm-dd'. */
  test_date?: Maybe<Scalars['String']['output']>;
  /** Type of test to be taken by the student. Possible values: B - No Writing, W - Plus Writing. */
  test_option?: Maybe<Scalars['String']['output']>;
  /** Type of test that was taken by the student. */
  test_type?: Maybe<Scalars['String']['output']>;
  /** Test Option status after the test date from External Registration System - B or W. */
  tested_test_option?: Maybe<Scalars['String']['output']>;
  /** List of who is registering. */
  who_is_registering?: Maybe<Array<Scalars['String']['output']>>;
};

export type UnityRegistrationDeviceCheckResults = {
  __typename?: 'UnityRegistrationDeviceCheckResults';
  /** The complete device check results. */
  completeDeviceCheckResults?: Maybe<Scalars['JSON']['output']>;
  /** The result of the device check. Possible values: pass or fail. */
  device_check_result: Scalars['String']['output'];
  /** The type of device check performed. Possible values: install, precheck, jit, or exam. */
  device_check_type: Scalars['String']['output'];
  /** The unique identifier of the registered device. */
  device_id: Scalars['String']['output'];
  /** The product identifier. */
  product_identifier: Scalars['String']['output'];
  /** The unique identifier of the registration. */
  registration_id: Scalars['String']['output'];
  /** The timestamp when the device check result was requested. */
  requested_at: Scalars['Float']['output'];
};

export type UnityRegistrationInfo = {
  __typename?: 'UnityRegistrationInfo';
  accomTypes: Array<UnityAccomType>;
  accommodation?: Maybe<UnityAccommodation>;
  admin?: Maybe<UnityAdminInfo>;
  /** Unique registration ID. */
  id: Scalars['ID']['output'];
  order?: Maybe<Array<UnityTsrOrder>>;
  program?: Maybe<UnityProgramInfo>;
  reg_modules?: Maybe<Array<UnityRegModule>>;
  registration: UnityRegistration;
  state: UnityRegStateType;
  test_center?: Maybe<Array<UnityTsrTestCenter>>;
  tir_eligibility?: Maybe<UnityTirEligibility>;
};

export type UnityTestCenter = {
  __typename?: 'UnityTestCenter';
  _id: Scalars['String']['output'];
  address: UnityAddress;
  colors: UnityColors;
  createdBy: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  /** A map containing all the products that the center provides. There is no fixed keys in this map. */
  products: Scalars['JSON']['output'];
  /** prefixed with the string literal "VER#", followed by an integer value, indicating the version of the record. VER#0 will always indicate the most recent record. */
  record_info: Scalars['String']['output'];
  testCenterId: Scalars['String']['output'];
  testCenterName: Scalars['String']['output'];
};

export type UnityTestCenterDeviceCheckResults = {
  __typename?: 'UnityTestCenterDeviceCheckResults';
  /** The complete device check results. */
  completeDeviceCheckResults?: Maybe<Scalars['JSON']['output']>;
  /** The result of the device check. Possible values: pass or fail. */
  device_check_result: Scalars['String']['output'];
  /** The type of device check performed. Possible values: install, precheck, jit, or exam. */
  device_check_type: Scalars['String']['output'];
  /** The unique identifier of the registered device. */
  device_id: Scalars['String']['output'];
  /** The product identifier. */
  product_identifier: Scalars['String']['output'];
  /** The timestamp when the device check result was requested. */
  requested_at: Scalars['Float']['output'];
  /** The unique identifier of the test center. */
  test_center_id: Scalars['String']['output'];
};

export type UnityTestLaunchIdentifier = {
  __typename?: 'UnityTestLaunchIdentifier';
  assessmentLabel: Scalars['String']['output'];
  assessmentStatus: Scalars['String']['output'];
  registrationId: Scalars['String']['output'];
  roomCode: Scalars['String']['output'];
};

export type UnityTestLaunchIdentifierInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  registrationId: Scalars['String']['input'];
  roomCode: Scalars['String']['input'];
};

export type UnityTestLaunchRequestData = {
  __typename?: 'UnityTestLaunchRequestData';
  body?: Maybe<Scalars['JSON']['output']>;
  headers?: Maybe<Scalars['JSON']['output']>;
  isSurvey: Scalars['Boolean']['output'];
  method: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UnityTestSite = {
  __typename?: 'UnityTestSite';
  _id: Scalars['String']['output'];
  address: UnityAddress;
  site_name: Scalars['String']['output'];
  site_type: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type UnityTirEligibility = {
  __typename?: 'UnityTirEligibility';
  /** Indicates if the registration is eligible for TIR. */
  eligibility: Scalars['Boolean']['output'];
  /** Indicates if the registration MC form code is TIR eligible. */
  mc_eligible?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the registration writing form code is TIR eligible. */
  writing_eligible?: Maybe<Scalars['Boolean']['output']>;
};

export type UnityTlpAssessment = {
  __typename?: 'UnityTlpAssessment';
  /** The order to display this test in the user interface. Example: 2. */
  display_order_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isSurvey: Scalars['Boolean']['output'];
  /** The UI button display label for the test. Example: English. */
  label: Scalars['String']['output'];
  /** Status indicator for the test. Possible values: A - Ready to start, X - Not ready to start (X will automatically turn to A when the previous assessment/survey is completed), L - Launched, C - Completed, T - Terminated. At any given moment, only one assessment/survey should be launchable (with a status of A  or L ). */
  status?: Maybe<Scalars['String']['output']>;
};

export type UnityTlpAssessmentInfo = {
  __typename?: 'UnityTlpAssessmentInfo';
  /** List of assessments to be taken. */
  assessments: Array<UnityTlpAssessment>;
  /** Directions to be shown on the launch page. */
  directions: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  /** Title to be shown on the launch page. Example: The ACT. */
  launch_page_title: Scalars['String']['output'];
};

export type UnityTlpTerms = {
  __typename?: 'UnityTlpTerms';
  accepted: Scalars['Boolean']['output'];
  content: Scalars['String']['output'];
};

export type UnityTools = {
  __typename?: 'UnityTools';
  tools?: Maybe<Array<Scalars['String']['output']>>;
};

export type UnityTsrOrder = {
  __typename?: 'UnityTsrOrder';
  created_by?: Maybe<Scalars['String']['output']>;
  created_dt?: Maybe<Scalars['String']['output']>;
  order_id: Scalars['ID']['output'];
  registration_id: Scalars['Int']['output'];
  test_center_assign_id?: Maybe<Scalars['Int']['output']>;
};

export type UnityTsrTestCenter = {
  __typename?: 'UnityTsrTestCenter';
  /** Status of examinee's test center accommodation. Possible values: P - Pending, C - Confirmed, H - On-Hold. */
  accom_status?: Maybe<Scalars['String']['output']>;
  /** Date when the registrant was assigned a test center. */
  assign_dt?: Maybe<Scalars['String']['output']>;
  /** Test Center assignment method used to assign the registrant. */
  assign_method?: Maybe<Scalars['String']['output']>;
  /** Booking code of the candidate in PSI. */
  booking_cd?: Maybe<Scalars['String']['output']>;
  /** Application/person who creates the record. */
  created_by?: Maybe<Scalars['String']['output']>;
  /** Datetime when the record is created. */
  created_dt?: Maybe<Scalars['String']['output']>;
  /** Date when the registrant was de-assigned from a test center. */
  deassign_dt?: Maybe<Scalars['String']['output']>;
  /** Unique test center assignment ID in the Registration database. */
  id: Scalars['ID']['output'];
  /** Location code of the selected international test center (Required for PSI calls). */
  location_cd?: Maybe<Scalars['String']['output']>;
  /** Location ID of the location within the test center from TCMS. */
  location_id?: Maybe<Scalars['Int']['output']>;
  /** Type of test location (test delivery type) from TCMS (Required for TCMS calls). */
  location_type?: Maybe<Scalars['String']['output']>;
  /** Application/person who modifies the record. */
  modified_by?: Maybe<Scalars['String']['output']>;
  /** Datetime when the record is modified. */
  modified_dt?: Maybe<Scalars['String']['output']>;
  /** Unique student registration ID. */
  registration_id?: Maybe<Scalars['Int']['output']>;
  /** Schedule date and time of the selected international test center (Required for PSI calls). */
  schedule_datetime?: Maybe<Scalars['String']['output']>;
  /** Status of examinee's test center. Possible values: B - Blocked, A - Assigned, D - Deassigned, C - Cancelled. */
  status?: Maybe<Scalars['String']['output']>;
  /** Test center listing code from TCMS (Required for TCMS calls). */
  tc_code?: Maybe<Scalars['String']['output']>;
  /** Test date ID from TCMS (Required for TCMS calls). */
  tc_date_id?: Maybe<Scalars['Int']['output']>;
  /** Test center ID from TCMS (Required for TCMS calls). */
  tc_id?: Maybe<Scalars['Int']['output']>;
  /** Test center notes. */
  tc_notes?: Maybe<Scalars['String']['output']>;
  /** High school code as a test center for registration with accommodations. */
  tc_override?: Maybe<Scalars['String']['output']>;
  /** Testing timeslot code selected for international scheduling (Required for PSI calls). */
  timeslot_cd?: Maybe<Scalars['String']['output']>;
};

export type UnityUiConfig = {
  __typename?: 'UnityUIConfig';
  address?: Maybe<UnityAddress>;
  colors?: Maybe<UnityColors>;
  name: Scalars['String']['output'];
  testCenterId: Scalars['String']['output'];
};

export type UnityUpdateDeviceCheckResultsInput = {
  deviceid: Scalars['String']['input'];
  results: DeviceCheckResultsInput;
  testcenterid: Scalars['String']['input'];
};

export type UnityUpdateRegistrationDeviceCheckResultsInput = {
  deviceid: Scalars['String']['input'];
  registrationid: Scalars['String']['input'];
  results: DeviceCheckResultsInput;
};

export type UnityUpdateTestCenterDeviceCheckResultsInput = {
  deviceid: Scalars['String']['input'];
  results: DeviceCheckResultsInput;
  testcenterid: Scalars['String']['input'];
};

export type AcceptAdminTermsMutationVariables = Exact<{
  input: UnityTestLaunchIdentifierInput;
}>;


export type AcceptAdminTermsMutation = { __typename?: 'Mutation', acceptAdminTerms: string };

export type OptInOutEosMutationVariables = Exact<{
  registrationId: Scalars['String']['input'];
  optIn: Scalars['Boolean']['input'];
}>;


export type OptInOutEosMutation = { __typename?: 'Mutation', optInOutEos: string };

export type PostExamineeDeviceCheckResultsMutationVariables = Exact<{
  input: UnityUpdateRegistrationDeviceCheckResultsInput;
}>;


export type PostExamineeDeviceCheckResultsMutation = { __typename?: 'Mutation', updateRegistrationDeviceCheckResults: string };

export type PostLaunchStatusUpdateMutationVariables = Exact<{
  assessmentId: Scalars['Int']['input'];
  registrationId: Scalars['String']['input'];
  roomCode: Scalars['String']['input'];
}>;


export type PostLaunchStatusUpdateMutation = { __typename?: 'Mutation', postLaunchStatusUpdate: string };

export type PostTestCenterDeviceCheckResultsMutationVariables = Exact<{
  input: UnityUpdateTestCenterDeviceCheckResultsInput;
}>;


export type PostTestCenterDeviceCheckResultsMutation = { __typename?: 'Mutation', updateTestCenterDeviceCheckResults: string };

export type UnityRefreshTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type UnityRefreshTokenMutation = { __typename?: 'Mutation', unityRefreshToken: { __typename?: 'UnityAuthToken', accessToken: string, exp: number, iat: number } };

export type RegisterDeviceMutationVariables = Exact<{
  tcId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
}>;


export type RegisterDeviceMutation = { __typename?: 'Mutation', registerDevice: string };

export type SigninFormMutationVariables = Exact<{
  input: Unity2UserLoginInput;
}>;


export type SigninFormMutation = { __typename?: 'Mutation', unity2Login: { __typename?: 'UnityAuthToken', accessToken: string, exp: number, iat: number } };

export type UnregisterDeviceMutationVariables = Exact<{
  tcId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
}>;


export type UnregisterDeviceMutation = { __typename?: 'Mutation', deRegisterDevice: string };

export type VendorCallbackStatusUpdateMutationVariables = Exact<{
  returnParameters: Scalars['String']['input'];
}>;


export type VendorCallbackStatusUpdateMutation = { __typename?: 'Mutation', vendorCallbackStatusUpdate: { __typename?: 'UnityTestLaunchIdentifier', assessmentLabel: string, assessmentStatus: string, registrationId: string, roomCode: string } };

export type DialogEnterRoomCodeQueryVariables = Exact<{
  input: UnityTestLaunchIdentifierInput;
}>;


export type DialogEnterRoomCodeQuery = { __typename?: 'Query', tlpGuard: string };

export type DialogTestCenterDetailsQueryVariables = Exact<{
  testCenterId: Scalars['Int']['input'];
}>;


export type DialogTestCenterDetailsQuery = { __typename?: 'Query', testSite: { __typename?: 'UnityTestSite', _id: string, site_name: string, address: { __typename?: 'UnityAddress', address: string, address2?: string | null, address3?: string | null, address4?: string | null, city: string, country: string, latitude?: number | null, longitude?: number | null, postalCode: string, state: string } } };

export type ExamineeDeviceCheckResultsQueryVariables = Exact<{
  input: GetDeviceCheckResultsByRegistrationInput;
}>;


export type ExamineeDeviceCheckResultsQuery = { __typename?: 'Query', registrationDeviceCheckResults?: { __typename?: 'UnityRegistrationDeviceCheckResults', completeDeviceCheckResults?: any | null, device_check_result: string, device_check_type: string, device_id: string, product_identifier: string, registration_id: string, requested_at: number } | null };

export type GuardRegistrationRoomCodeQueryVariables = Exact<{
  input: UnityTestLaunchIdentifierInput;
}>;


export type GuardRegistrationRoomCodeQuery = { __typename?: 'Query', tlpGuard: string };

export type GuardTestCenterQueryVariables = Exact<{
  testCenterId: Scalars['String']['input'];
}>;


export type GuardTestCenterQuery = { __typename?: 'Query', testCenter: { __typename?: 'UnityTestCenter', _id: string } };

export type HydrateDeviceChecksToRunQueryVariables = Exact<{
  input: UnityGetConfigInput;
}>;


export type HydrateDeviceChecksToRunQuery = { __typename?: 'Query', getUnityConfig: { __typename?: 'UnityConfiguration', _id: string, identifier: string, version: string, product: { __typename?: 'UnityProduct', _id: string, name: string, identifier: string, version?: string | null, testCenterProviding: boolean, displayOnDevice: boolean, attributes?: { __typename?: 'UnityProductAttributes', accessibility?: { __typename?: 'UnityAccessibility', calculatorEndpoint?: string | null, os?: { __typename?: 'UnityOs', MacOS?: { __typename?: 'UnityTools', tools?: Array<string> | null } | null, Windows?: { __typename?: 'UnityTools', tools?: Array<string> | null } | null } | null } | null } | null, uiConfig?: { __typename?: 'UnityUIConfig', testCenterId: string, name: string, address?: { __typename?: 'UnityAddress', address: string, address2?: string | null, address3?: string | null, address4?: string | null, city: string, state: string, postalCode: string, country: string, latitude?: number | null, longitude?: number | null } | null, colors?: { __typename?: 'UnityColors', primary: string, secondary: string, text: string } | null } | null, deliveryEngine?: { __typename?: 'UnityDeliveryEngine', engineType: string, idleTimeout: number } | null, deviceCheck: { __typename?: 'UnityDeviceCheck', install?: { __typename?: 'UnityInstall', requiresDeviceIntegrity: boolean, requiresDeviceLockdown?: boolean | null, minimumBatteryLevel: number, externalStorageProhibited: boolean, requiresSecureNetwork: boolean, requiredACTEndpoint: string, multipleMonitorsProhibited?: boolean | null, minimumOSVersion: { __typename?: 'UnityMinimumOSVersion', Windows?: string | null, MacOS?: string | null, ChromeOS: string, Android: string, iOS: string }, minimumUnityVersion: { __typename?: 'UnityMinimumUnityVersion', Windows?: string | null, iOS: string, ChromeOS: string, Android: string, MacOS?: string | null }, minScreenSize: { __typename?: 'UnityMinScreenSize', Windows?: string | null, iOS: string, ChromeOS: string, Android: string, MacOS?: string | null } } | null, preCheck?: { __typename?: 'UnityPreCheckJIT', externalApplicationsProhibited: boolean, requiresDeviceIntegrity: boolean, requiresDeviceLockdown?: boolean | null, minimumBatteryLevel: number, externalStorageProhibited: boolean, requiresSecureNetwork: boolean, requiredACTEndpoint: string, requiredProductEndpoints: Array<string>, multipleMonitorsProhibited?: boolean | null, minScreenSize: { __typename?: 'UnityMinScreenSize', Windows?: string | null, iOS: string, ChromeOS: string, Android: string, MacOS?: string | null }, minimumOSVersion: { __typename?: 'UnityMinimumOSVersion', Windows?: string | null, MacOS?: string | null, ChromeOS: string, Android: string, iOS: string }, minimumUnityVersion: { __typename?: 'UnityMinimumUnityVersion', Windows?: string | null, iOS: string, ChromeOS: string, Android: string, MacOS?: string | null } } | null, JIT?: { __typename?: 'UnityPreCheckJIT', externalApplicationsProhibited: boolean, requiresDeviceIntegrity: boolean, requiresDeviceLockdown?: boolean | null, minimumBatteryLevel: number, externalStorageProhibited: boolean, requiresSecureNetwork: boolean, requiredACTEndpoint: string, requiredProductEndpoints: Array<string>, multipleMonitorsProhibited?: boolean | null, minScreenSize: { __typename?: 'UnityMinScreenSize', Windows?: string | null, iOS: string, ChromeOS: string, Android: string, MacOS?: string | null }, minimumOSVersion: { __typename?: 'UnityMinimumOSVersion', Windows?: string | null, MacOS?: string | null, ChromeOS: string, Android: string, iOS: string }, minimumUnityVersion: { __typename?: 'UnityMinimumUnityVersion', Windows?: string | null, iOS: string, ChromeOS: string, Android: string, MacOS?: string | null } } | null, exam?: { __typename?: 'UnityExam', touchScreen: string, externalStorageProhibited: boolean, repeatFrequency: number, minimumBatteryLevel: number, multipleMonitorsProhibited?: boolean | null } | null } } } };

export type IndexPageQueryVariables = Exact<{
  currentDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type IndexPageQuery = { __typename?: 'Query', myRegistrations: Array<{ __typename?: 'UnityRegistrationInfo', id: string, state: UnityRegStateType, admin?: { __typename?: 'UnityAdminInfo', admin_end_date?: string | null, admin_id: string, admin_start_date?: string | null } | null, program?: { __typename?: 'UnityProgramInfo', program_id: string, program_name: string } | null, registration: { __typename?: 'UnityRegistration', id: string }, test_center?: Array<{ __typename?: 'UnityTsrTestCenter', id: string, schedule_datetime?: string | null, tc_id?: number | null }> | null }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me: { __typename?: 'UnityMe', id: string, firstName: string, lastName: string, photoExempt: boolean } };

export type MyPhotoQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPhotoQuery = { __typename?: 'Query', myPhotoUrl: { __typename?: 'UnityPhotoUrl', durationInSec?: number | null, id: string, url: string } };

export type RegistrationLayoutQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RegistrationLayoutQuery = { __typename?: 'Query', registration?: { __typename?: 'UnityRegistrationInfo', id: string, program?: { __typename?: 'UnityProgramInfo', program_id: string, program_name: string } | null } | null };

export type RegistrationPageQueryVariables = Exact<{
  currentDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
}>;


export type RegistrationPageQuery = { __typename?: 'Query', registration?: { __typename?: 'UnityRegistrationInfo', id: string, accomTypes: Array<UnityAccomType>, state: UnityRegStateType, admin?: { __typename?: 'UnityAdminInfo', admin_end_date?: string | null, admin_id: string, admin_start_date?: string | null, photo_upload_deadline?: string | null } | null, program?: { __typename?: 'UnityProgramInfo', program_id: string, program_name: string } | null, reg_modules?: Array<{ __typename?: 'UnityRegModule', moduleId?: number | null, name: string }> | null, registration: { __typename?: 'UnityRegistration', eos_opt_in?: boolean | null, id: string }, test_center?: Array<{ __typename?: 'UnityTsrTestCenter', id: string, schedule_datetime?: string | null, tc_code?: string | null, tc_id?: number | null }> | null } | null };

export type RegistrationRoomCodeCheckPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type RegistrationRoomCodeCheckPageQuery = { __typename?: 'Query', registration?: { __typename?: 'UnityRegistrationInfo', id: string, test_center?: Array<{ __typename?: 'UnityTsrTestCenter', id: string, tc_code?: string | null }> | null } | null };

export type RegistrationRoomCodeEosPageQueryVariables = Exact<{
  registrationId: Scalars['String']['input'];
}>;


export type RegistrationRoomCodeEosPageQuery = { __typename?: 'Query', registration?: { __typename?: 'UnityRegistrationInfo', id: string, accomTypes: Array<UnityAccomType>, state: UnityRegStateType, registration: { __typename?: 'UnityRegistration', eos_opt_in?: boolean | null, id: string }, program?: { __typename?: 'UnityProgramInfo', program_name: string } | null } | null };

export type RegistrationRoomCodeInfoPageQueryVariables = Exact<{
  registrationId: Scalars['String']['input'];
}>;


export type RegistrationRoomCodeInfoPageQuery = { __typename?: 'Query', me: { __typename?: 'UnityMe', id: string, firstName: string, lastName: string }, registration?: { __typename?: 'UnityRegistrationInfo', id: string, test_center?: Array<{ __typename?: 'UnityTsrTestCenter', id: string, tc_id?: number | null }> | null } | null };

export type RegistrationRoomCodeInfoPageTestCenterQueryVariables = Exact<{
  testCenterId: Scalars['String']['input'];
}>;


export type RegistrationRoomCodeInfoPageTestCenterQuery = { __typename?: 'Query', testCenter: { __typename?: 'UnityTestCenter', _id: string, testCenterName: string } };

export type RegistrationRoomCodeInfoPageTestSiteQueryVariables = Exact<{
  testCenterId: Scalars['Int']['input'];
}>;


export type RegistrationRoomCodeInfoPageTestSiteQuery = { __typename?: 'Query', testSite: { __typename?: 'UnityTestSite', _id: string, site_name: string } };

export type RegistrationRoomCodeLaunchQueryVariables = Exact<{
  input: UnityTestLaunchIdentifierInput;
  registrationId: Scalars['String']['input'];
}>;


export type RegistrationRoomCodeLaunchQuery = { __typename?: 'Query', assessmentsInfo: { __typename?: 'UnityTlpAssessmentInfo', directions: string, id: number, assessments: Array<{ __typename?: 'UnityTlpAssessment', display_order_id: number, id: number, isSurvey: boolean, label: string, status?: string | null }> }, registration?: { __typename?: 'UnityRegistrationInfo', accomTypes: Array<UnityAccomType>, state: UnityRegStateType, program?: { __typename?: 'UnityProgramInfo', program_name: string } | null } | null };

export type RegistrationRoomCodeStatementsPageQueryVariables = Exact<{
  input: UnityTestLaunchIdentifierInput;
  registrationId: Scalars['String']['input'];
}>;


export type RegistrationRoomCodeStatementsPageQuery = { __typename?: 'Query', myAdminTerms: { __typename?: 'UnityTlpTerms', accepted: boolean, content: string }, registration?: { __typename?: 'UnityRegistrationInfo', accomTypes: Array<UnityAccomType>, state: UnityRegStateType, program?: { __typename?: 'UnityProgramInfo', program_name: string } | null } | null };

export type RenderAssessmentTestLaunchRequestDataQueryVariables = Exact<{
  assessmentId: Scalars['Int']['input'];
  registrationId: Scalars['String']['input'];
  roomCode: Scalars['String']['input'];
}>;


export type RenderAssessmentTestLaunchRequestDataQuery = { __typename?: 'Query', testLaunchRequestData: { __typename?: 'UnityTestLaunchRequestData', body?: any | null, headers?: any | null, isSurvey: boolean, method: string, url: string } };

export type RoomCodeLayoutQueryVariables = Exact<{
  registrationId: Scalars['String']['input'];
  roomCode: Scalars['String']['input'];
}>;


export type RoomCodeLayoutQuery = { __typename?: 'Query', myAdminTerms: { __typename?: 'UnityTlpTerms', accepted: boolean }, registration?: { __typename?: 'UnityRegistrationInfo', id: string, registration: { __typename?: 'UnityRegistration', eos_opt_in?: boolean | null, id: string } } | null };

export type StaffPageQueryVariables = Exact<{
  testCenterId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
}>;


export type StaffPageQuery = { __typename?: 'Query', verifyTestCenterDeviceMapping: boolean, testCenter: { __typename?: 'UnityTestCenter', _id: string, testCenterName: string } };

export type StaffTestCenterAboutPageQueryVariables = Exact<{
  testCenterId: Scalars['String']['input'];
}>;


export type StaffTestCenterAboutPageQuery = { __typename?: 'Query', testCenter: { __typename?: 'UnityTestCenter', _id: string, address: { __typename?: 'UnityAddress', city: string, state: string } } };

export type StaffTestCenterDeviceCheckResultsQueryVariables = Exact<{
  input: GetDeviceCheckResultsByTestCenterInput;
}>;


export type StaffTestCenterDeviceCheckResultsQuery = { __typename?: 'Query', testCenterDeviceCheckResults?: { __typename?: 'UnityTestCenterDeviceCheckResults', completeDeviceCheckResults?: any | null, device_check_result: string, device_check_type: string, device_id: string, product_identifier: string, requested_at: number, test_center_id: string } | null };

export type StaffTestCenterLayoutQueryVariables = Exact<{
  testCenterId: Scalars['String']['input'];
}>;


export type StaffTestCenterLayoutQuery = { __typename?: 'Query', testCenter: { __typename?: 'UnityTestCenter', _id: string, testCenterName: string, address: { __typename?: 'UnityAddress', city: string, state: string } } };

export type StaffTestCenterRegisterPageQueryVariables = Exact<{
  testCenterId: Scalars['String']['input'];
}>;


export type StaffTestCenterRegisterPageQuery = { __typename?: 'Query', testCenter: { __typename?: 'UnityTestCenter', _id: string, testCenterName: string } };

export type VerifyTestCenterDeviceMappingQueryVariables = Exact<{
  tcId: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
}>;


export type VerifyTestCenterDeviceMappingQuery = { __typename?: 'Query', verifyTestCenterDeviceMapping: boolean };
